import { render, staticRenderFns } from "./CreateTransactionModal.vue?vue&type=template&id=c5aa44f2&scoped=true&"
import script from "./CreateTransactionModal.vue?vue&type=script&lang=js&"
export * from "./CreateTransactionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5aa44f2",
  null
  
)

export default component.exports